

(function fieldErrorDirectiveDefinition() {

    'use strict';

    // esta directiva permite mostrar mensajes de error en los campos de un formulario.
    angular.module('Errors')
        .value('fieldErrorDefaultMessages', {
        })
        .directive('fieldError', ['$translate', 'fieldErrorDefaultMessages', function fieldErrorDirective($translate, fieldErrorDefaultMessages) {
            return {
                require: ['ngModel', '^form', '^showError'],
                restrict: 'A',
                scope: {
                    fieldError: '&'
                },
                link: function fieldErrorDirectiveLink($scope, element, attrs, ctrls) {

                    var ngModel = ctrls[0];
                    var formCtrl = ctrls[1];
                    var showErrorCtrl = ctrls[2];

                    var errorElement = angular.element('<span class="text-small block"></span>');

                    var updateErrorLabel = function updateErrorLabel(showErrorCtrl) {

                        if ($scope.fieldError) {

                            var fieldErrorLabels = $scope.fieldError() || {};

                            var show = showErrorCtrl.showAlways || (formCtrl.$submitted || (ngModel.$dirty && !showErrorCtrl.onSubmit));

                            if (!show || (ngModel.$valid && (fieldErrorLabels.ok === '' || fieldErrorLabels.hideSuccess === true))) {
                                errorElement.detach();
                            } else {

                                if (ngModel.$invalid) {

                                    var errors = [];

                                    angular.forEach(ngModel.$error, function (value, key) {
                                        if (value) {
                                            errors.push($translate.instant(fieldErrorLabels[key] || fieldErrorDefaultMessages[key] || 'FieldError_' + key));
                                        }
                                    });

                                    errorElement.text(errors.join(', '));

                                    errorElement.removeClass('success');
                                    errorElement.addClass('error');
                                } else {
                                    errorElement.text($translate.instant(fieldErrorLabels.ok || fieldErrorDefaultMessages['ok'] || ''));

                                    errorElement.removeClass('error');
                                    errorElement.addClass('success');
                                }

                                if (!errorElement.parent().length) {
                                    element.parent().append(errorElement);
                                }
                            }
                        }
                    }

                    showErrorCtrl.onUpdate(updateErrorLabel);

                    $scope.$watch(function () {
                        return ngModel.$viewValue;
                    }, function () {
                        updateErrorLabel(showErrorCtrl);
                    });
                }
            };
        }])
        .directive('fieldErrorLabel', [function fieldErrorDirective() {
            return {
                require: '^showError',
                restrict: 'A',
                link: function fieldErrorLabelDirectiveLink($scope, element, attrs, showErrorCtrl) {

                    var errorElement = angular.element('<span class="symbol"></span>');

                    element.append(errorElement);

                    function updateErrorLabel(ctrl) {

                        var show = showErrorCtrl.showAlways || (formCtrl.$submitted || (ngModel.$dirty && !showErrorCtrl.onSubmit));

                        if (show) {
                            errorElement.show();
                        } else {
                            errorElement.hide();
                        }
                    }

                    showErrorCtrl.onUpdate(updateErrorLabel);

                    updateErrorLabel(showErrorCtrl);
                }
            };
        }]);

})();